import React, { useState } from 'react';
import {
  Form,
  Input,
  Table
} from 'semantic-ui-react';

const Achievements = ({ update, config }) => {
  const [steamID, setSteamID] = useState(config.SteamID || '')

  const updateSteamID = (ev) => {
    update('SteamID', ev.target.value);
    setSteamID(ev.target.value)
  }

  return (
    <React.Fragment>
      <Table.Row>
        <Table.Cell collapsing verticalAlign='top'><strong>Steam ID</strong></Table.Cell>
        <Table.Cell>
          <Input value={steamID} onChange={updateSteamID} fluid /><br />
          Enter your Steam ID, or your Steam custom url value.
        </Table.Cell>
      </Table.Row>
    </React.Fragment>
  )
}

const Friend = ({ update, config }) => {
  const [subFriends, setSubFriends] = useState(config.subFriends !== undefined ? config.subFriends : true);

  const toggleSubFriends = (ev, data) => {
    update('subFriends', data.checked);
    setSubFriends(data.checked);
  };

  return (
    <React.Fragment>
      <Table.Row>
        <Table.Cell collapsing verticalAlign='top'><strong>Subscriber Friends</strong></Table.Cell>
        <Table.Cell>
          <Form.Checkbox toggle checked={subFriends} onChange={toggleSubFriends} />
          When enabled, only subscribers will be able to specify a friend to spawn. When disabled, anyone can specify a friend to spawn.
        </Table.Cell>
      </Table.Row>
    </React.Fragment>
  )
}

const Repeat = ({ update, config }) => {
  const [limit, setLimit] = useState(config.limit || 5);
  const [subLimit, setSubLimit] = useState(config.subLimit || 25);

  const updateLimit = (ev) => {
    let limitValue = parseInt(ev.target.value);
    if (limitValue < 0 || !limitValue) {
      limitValue = 1;
    } else if (limitValue > 50) {
      limitValue = 50;
    }
    update('limit', limitValue);
    setLimit(limitValue);
  }

  const updateSubLimit = (ev) => {
    let limitValue = parseInt(ev.target.value);
    if (limitValue < 0 || !limitValue) {
      limitValue = 1;
    } else if (limitValue > 50) {
      limitValue = 50;
    }
    update('subLimit', limitValue);
    setSubLimit(limitValue);
  }

  return (
    <React.Fragment>
      <Table.Row>
        <Table.Cell collapsing verticalAlign='top'><strong>Limit</strong></Table.Cell>
        <Table.Cell>
          <Input value={limit} type='number' min='1' max='50' onChange={updateLimit} />
          <br />The maximum number of times a command can be repeated for non-subscribers.
        </Table.Cell>
      </Table.Row>
      <Table.Row>
        <Table.Cell collapsing verticalAlign='top'><strong>Subscribers Limit</strong></Table.Cell>
        <Table.Cell>
          <Input value={subLimit} type='number' min='1' max='50' onChange={updateSubLimit} />
          <br />The maximum number of times a command can be repeated for subscribers.
        </Table.Cell>
      </Table.Row>
    </React.Fragment>
  )
}

const Configs = {
  'achievements': Achievements,
  'friend': Friend,
  'repeat': Repeat,
}

export default Configs;
